module.exports = __webpack_public_path__ + "img/icon_sm_zjjerb.014764df.png";